module.exports = __webpack_public_path__ + "static/media/u(filled).0645e4fa.svg";